import { render } from "./Faqhomepage.vue?vue&type=template&id=a311caa8"
import script from "./Faqhomepage.vue?vue&type=script&lang=js"
export * from "./Faqhomepage.vue?vue&type=script&lang=js"

import "./Faqhomepage.vue?vue&type=style&index=0&id=a311caa8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__